const WORDS = [
  "Свобода",
  "Приватность",
  "AI-сервисы",
  "ChatGPT",
  "Claude",
  "Midjourney",
  "Gemini",
  "Copilot",
  "NORA",
  "Свои сервисы",
  "Любимая музыка",
];

export default function Marquee() {
  const row = [...WORDS, ...WORDS];
  return (
    <div
      data-testid="marquee"
      aria-hidden="true"
      className="select-none overflow-hidden py-4 sm:py-8"
    >
      <div className="animate-marquee flex w-max items-center">
        {row.map((word, i) => (
          <span
            key={`${word}-${i}`}
            className="flex items-center font-display text-3xl font-extrabold text-nora-ink/10 sm:text-5xl"
          >
            <span className="px-6">{word}</span>
            <span className="text-2xl text-nora-accent/30 sm:text-4xl">•</span>
          </span>
        ))}
      </div>
    </div>
  );
}
